import React from 'react';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import FormControl from '@mui/material/FormControl';

const CustomDateTimeField = ({ margin, disabled, value, onChange, label, minDateTime }) => (
  <LocalizationProvider dateAdapter={AdapterDayjs}>
    <FormControl fullWidth margin={margin} disabled={disabled}>
      <DateTimePicker
        value={value}
        onChange={onChange}
        disablePast
        label={label}
        ampm={false}
        minutesStep={15}
        minDateTime={minDateTime}
      />
    </FormControl>
  </LocalizationProvider>
);

export default CustomDateTimeField;
